import { ILead } from 'src/interfaces/lead';
import { IUser } from 'src/interfaces/user';
import { STATUSES } from 'src/constants/mongo/status';
import { USER_LEVEL_ACCESS } from 'src/components/access';

/**
 * Validates if the vehicle delivery date can be edited based on the lead's substatus and user's access level
 * @param lead - The lead object to check
 * @param user - The user object to check
 * @returns True if the vehicle delivery date can be edited, false otherwise
 */

export const validateEditableVehicleDeliveryDate = ({
    lead,
    user,
}: {
    lead: ILead;
    user: IUser;
}): boolean => {
    const SUBSTATUS_SOLD_SUCCESS =
        STATUSES.CLOSURE_INFORMATION.SUBSTATUSES.SOLD.ID;

    if (
        !lead.vehicleDeliveryDate &&
        lead.substatus._id === SUBSTATUS_SOLD_SUCCESS
    )
        return true;

    if (!user?.accessLevel) return false;

    if (
        lead.substatus._id === SUBSTATUS_SOLD_SUCCESS &&
        user.accessLevel !== USER_LEVEL_ACCESS
    ) {
        return true;
    }

    return false;
};
